define(["require", "exports", "tslib", "axios", "../bootstrap/BootstrapManager"], function (require, exports, tslib_1, axios_1, BootstrapManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.InterceptorLocalAuth = exports.getCurrentService = exports.getCdnConfig = exports.isDevAndTestEnvirement = exports.isLocalMode = exports.getHashParams = exports.getQueryVariable = exports.SPECIAL_LOCAL_FLAG = exports.SPECIAL_SPLITER_FLAG = void 0;
    axios_1 = (0, tslib_1.__importDefault)(axios_1);
    exports.SPECIAL_SPLITER_FLAG = 'authInfo=';
    exports.SPECIAL_LOCAL_FLAG = 'local-refresh-flag';
    function getQueryVariable() {
        var queryData = {};
        var query = window.location.search.substring(1);
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var spliter = vars[i];
            if (spliter.indexOf(exports.SPECIAL_SPLITER_FLAG) === -1) {
                var pair = spliter.split('=');
                if (pair.length) {
                    queryData[pair[0]] = pair[1];
                }
            }
            else {
                queryData.authInfo = spliter.replace(exports.SPECIAL_SPLITER_FLAG, '');
            }
        }
        return queryData;
    }
    exports.getQueryVariable = getQueryVariable;
    function getHashParams() {
        var hashParams = {};
        if (window.location.href.indexOf('#') !== -1) {
            var hashUrl = window.location.hash;
            var hashUrlList = hashUrl.split('?');
            if (hashUrlList && hashUrlList.length === 2) {
                var rightParamsList = hashUrlList[1].split('&');
                while (rightParamsList.length) {
                    var rightItem = rightParamsList.shift();
                    var rightItemList = rightItem.split('=');
                    if (rightItemList && rightItemList.length === 2) {
                        hashParams[rightItemList[0]] = rightItemList[1];
                    }
                }
            }
        }
        return hashParams;
    }
    exports.getHashParams = getHashParams;
    function isLocalMode() {
        var isLocal = false;
        if (process && process.env) {
            if (process.env.NODE_ENV === 'development' &&
                process.env.VUE_APP_BASE_API === '/dev-api' &&
                process.env.VUE_APP_LOCAL_FLAG === '.env.development') {
                isLocal = true;
            }
        }
        return isLocal;
    }
    exports.isLocalMode = isLocalMode;
    function isDevAndTestEnvirement() {
        var isNoneProd = false;
        var localAddress = window.location.href;
        if (localAddress.indexOf('dev.') !== -1 ||
            localAddress.indexOf('dev2.') !== -1 ||
            localAddress.indexOf('dev3.') !== -1 ||
            localAddress.indexOf('dev4.') !== -1 ||
            localAddress.indexOf('dev5.') !== -1 ||
            localAddress.indexOf('dev6.') !== -1 ||
            localAddress.indexOf('dev7.') !== -1 ||
            localAddress.indexOf('dev8.') !== -1 ||
            localAddress.indexOf('dev9.') !== -1 ||
            localAddress.indexOf('dev10.') !== -1 ||
            localAddress.indexOf('test.') !== -1 ||
            localAddress.indexOf('test2.') !== -1 ||
            localAddress.indexOf('test3.') !== -1 ||
            localAddress.indexOf('test4.') !== -1 ||
            localAddress.indexOf('test5.') !== -1 ||
            localAddress.indexOf('test6.') !== -1 ||
            localAddress.indexOf('test7.') !== -1 ||
            localAddress.indexOf('test8.') !== -1 ||
            localAddress.indexOf('test9.') !== -1 ||
            localAddress.indexOf('test10.') !== -1 ||
            localAddress.indexOf('test-bfc-') !== -1 ||
            localAddress.indexOf('test2-bfc-') !== -1 ||
            localAddress.indexOf('test3-bfc-') !== -1 ||
            localAddress.indexOf('test4-bfc-') !== -1 ||
            localAddress.indexOf('test5-bfc-') !== -1 ||
            localAddress.indexOf('test6-bfc-') !== -1 ||
            localAddress.indexOf('test7-bfc-') !== -1 ||
            localAddress.indexOf('test8-bfc-') !== -1 ||
            localAddress.indexOf('test9-bfc-') !== -1 ||
            localAddress.indexOf('test10-bfc-') !== -1 ||
            localAddress.indexOf('dev-bfc-') !== -1 ||
            localAddress.indexOf('dev2-bfc-') !== -1 ||
            localAddress.indexOf('dev3-bfc-') !== -1 ||
            localAddress.indexOf('dev4-bfc-') !== -1 ||
            localAddress.indexOf('dev5-bfc-') !== -1 ||
            localAddress.indexOf('dev6-bfc-') !== -1 ||
            localAddress.indexOf('dev7-bfc-') !== -1 ||
            localAddress.indexOf('dev8-bfc-') !== -1 ||
            localAddress.indexOf('dev9-bfc-') !== -1 ||
            localAddress.indexOf('dev10-bfc-') !== -1) {
            isNoneProd = true;
        }
        localAddress = window.location.host;
        if (localAddress.startsWith('dev-') || localAddress.startsWith('test-')) {
            isNoneProd = true;
        }
        return isNoneProd;
    }
    exports.isDevAndTestEnvirement = isDevAndTestEnvirement;
    function getCdnConfig() {
        var configData = BootstrapManager_1.bootStrapManager.getConfig();
        var cdnConfig = '';
        var cdnHostAddress = window.location.host;
        var cdnDomainAddress = configData.cdnConfigProdDomain;
        cdnConfig = "".concat(cdnDomainAddress, "/").concat(cdnHostAddress, "/");
        console.log('getCdnConfig>>', cdnConfig);
        if (isLocalMode() || isDevAndTestEnvirement()) {
            cdnDomainAddress = configData.cdnConfigTestDomain;
            cdnConfig = "".concat(cdnDomainAddress, "/").concat(cdnHostAddress.replace('test-', ''), "/");
            if (isLocalMode()) {
                cdnConfig = "".concat(cdnDomainAddress, "/").concat(getCurrentService().replace('test-', ''), "/");
            }
        }
        console.log('getCdnConfig>> RESULT ', cdnConfig);
        return cdnConfig;
    }
    exports.getCdnConfig = getCdnConfig;
    function getCurrentService() {
        var config = BootstrapManager_1.bootStrapManager.getConfig();
        var defaultChannel = config.defaultChannel || '/order';
        var serviceUrl = config.proxyTable[defaultChannel].realService;
        serviceUrl = serviceUrl.replace(defaultChannel, '');
        serviceUrl = serviceUrl.replace(/(http|https):\/\//gi, '');
        return serviceUrl;
    }
    exports.getCurrentService = getCurrentService;
    var InterceptorLocalAuth = (function () {
        function InterceptorLocalAuth() {
            this.configData = BootstrapManager_1.bootStrapManager.getConfig();
        }
        InterceptorLocalAuth.prototype.interceptorDevelopement = function () {
            var _a;
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var result, localFlagDataSource, localFlagData, baseURL, mockURL, localAddress, resDataSource, resData, error_1;
                return (0, tslib_1.__generator)(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            console.log('isIn interceptorDevelopement');
                            result = false;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, , 5]);
                            localFlagDataSource = localStorage.getItem(exports.SPECIAL_LOCAL_FLAG);
                            localFlagData = JSON.parse(localFlagDataSource);
                            if (!(localFlagData && localFlagData.needRefresh)) return [3, 3];
                            result = true;
                            localStorage.removeItem(exports.SPECIAL_LOCAL_FLAG);
                            baseURL = this.getConfgServerUrl();
                            mockURL = this.getMockServerUrl();
                            localAddress = this.getRedirectServerUrl();
                            return [4, this.fetchRemoteCookie(baseURL)];
                        case 2:
                            resDataSource = _b.sent();
                            resData = resDataSource.data || {};
                            if ((_a = resData === null || resData === void 0 ? void 0 : resData.data) === null || _a === void 0 ? void 0 : _a.authInfo) {
                                window.location.href = "".concat(mockURL, "/mock-api/v1/roles?authInfo=").concat(resData.data.authInfo, "&localAddress=").concat(localAddress);
                            }
                            else {
                                console.log('authinfo 不存在');
                            }
                            _b.label = 3;
                        case 3: return [3, 5];
                        case 4:
                            error_1 = _b.sent();
                            console.log('develop parse error', error_1);
                            return [3, 5];
                        case 5: return [2, result];
                    }
                });
            });
        };
        InterceptorLocalAuth.prototype.interceptorServerAuth = function () {
            console.log('interceptorServerAuth...');
            var isLocal = isLocalMode();
            if (isLocal) {
                var defaultChannel = this.configData.defaultChannel;
                var proxyTable = this.configData.proxyTable;
                var proxyItem = proxyTable[defaultChannel];
                if (proxyItem && proxyItem.realService) {
                    var realService = proxyItem.realService.replace(defaultChannel, '');
                    var localAddress = this.getRedirectServerUrl();
                    var localTransferAddress = this.getMockServerUrl();
                    var redirectUrl = "".concat(realService, "/mock-api/v1/users/logout?localAddress=").concat(localAddress, "&localTransferAddress=").concat(localTransferAddress);
                    if (this.configData && this.configData.useLocalCustomLogoutUrl && this.configData.useLocalCustomRealLogoutUrl) {
                        redirectUrl = "".concat(realService, "/api/v1/users/logout?localAddress=").concat(localAddress, "&localTransferAddress=").concat(localTransferAddress, "&useLocalCustomRealLogoutUrl=").concat(this.configData.useLocalCustomRealLogoutUrl);
                    }
                    window.location.href = redirectUrl;
                }
            }
        };
        InterceptorLocalAuth.prototype.getCurrentRemoteServerUrl = function () {
            var realService = '';
            var defaultChannel = this.configData.defaultChannel;
            var proxyTable = this.configData.proxyTable;
            var proxyItem = proxyTable[defaultChannel];
            if (proxyItem && proxyItem.realService) {
                realService = proxyItem.realService;
            }
            return realService;
        };
        InterceptorLocalAuth.prototype.fetchRemoteCookie = function (baseURL) {
            return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
                var _this = this;
                return (0, tslib_1.__generator)(this, function (_a) {
                    return [2, new Promise(function (resolve, reject) {
                            var instance = axios_1.default.create({
                                baseURL: baseURL,
                                withCredentials: true
                            });
                            instance.defaults.withCredentials = true;
                            var configUrl = _this.configData.useLocalCustomAuthUrl ? _this.configData.useLocalCustomAuthUrl : '/mock-api/v1/users/test';
                            console.log('request config url===>', configUrl);
                            instance.get(configUrl).then(function (response) {
                                resolve(response);
                            });
                        })];
                });
            });
        };
        InterceptorLocalAuth.prototype.getConfgServerUrl = function () {
            return window.location.origin;
        };
        InterceptorLocalAuth.prototype.getRedirectServerUrl = function () {
            return "".concat(this.configData.devHost, ":").concat(this.configData.devServerPort);
        };
        InterceptorLocalAuth.prototype.getMockServerUrl = function () {
            return "".concat(this.configData.mockHost, ":").concat(this.configData.mockServerPort);
        };
        return InterceptorLocalAuth;
    }());
    exports.InterceptorLocalAuth = InterceptorLocalAuth;
});
//# sourceMappingURL=InterceptorLocalAuth.js.map